import { Badge, Box } from "@mui/material";
import UserProfile from "../../features/main-page/components/get-conversation/UserProfile";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import "../Views/promoCode.css";

const NavbarPromoCode = () => {
  return (
    <Box>
      <Box className="logoPrompCode">
        <img className="expertex-logo c-pointer d-block" />
        <Box className="header-center">
          <Box className="notification-center">
            <Badge
              color="secondary"
              variant="dot"
              sx={{
                "& .MuiBadge-dot": {
                  backgroundColor: "#FF2D2D",
                },
              }}
            >
              <NotificationsNoneOutlinedIcon />
            </Badge>
          </Box>
          <UserProfile />
        </Box>
      </Box>
    </Box>
  );
};

export default NavbarPromoCode;
